import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Toast from "../../helpers/Toast";
import Layout from "../../components/Layout/Layout";
import { IoArrowBackSharp } from "react-icons/io5";
import { Col, Row } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import { ClientQuotationService } from "../../services/ClientQuotationService";
import { ClientQuotationDTO } from "../../models/Quotation/ClientQuotationDTO";
import DetailsQuotationPartsTable from "../../components/Quotation/DetailsQuotationPartsTable";
import ButtonComponent from "../../components/ButtonComponent";
import SearchSelectComponent, { SelectItemsProps } from "../../components/SearchSelectComponent";
import { PartQuotationListDTO } from "../../models/Quotation/PartQuotationListDTO";
import { Utilities } from "../../helpers/Utilities";
import { UpdateClientQuotationDTO } from "../../models/Quotation/UpdateClientQuotationDTO";
import { PartsAndServicesQuotationDTO } from "../../models/Quotation/PartsAndServicesQuotationDTO";
import Routes from "../../helpers/Routes";
import DecisionModal from "../../components/Quotation/DecisionQuotation";
import { ApproveClientQuotationDTO } from "../../models/Quotation/ApproveClientQuotationDTO";
import { useAuth } from "../../context/AuthContext";
import { GetDocNumberDTO } from "../../models/Assistance/GetDocNumberDTO";
import { AssistanceService } from "../../services/AssistanceService";
import PageTitle from "../../components/Layout/PageTitle";
import { CreateClientQuotationDTO } from "../../models/Quotation/CreateClientQuotationDTO";
import { Console } from "console";
import ModalComponent from "../../components/ModalComponent";
import SelectAssistanceModal from "../../components/Quotation/SelectAssistanceModel";
import { UpdateClientQuotationAssistanceDTO } from "../../models/Quotation/UpdateClientQuotationAssistanceDTO";
import { Parameter } from "../../models/Parameter";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";

export default function DetailsClientQuotation() {
    const location = useLocation();
    const { userRoles } = useAuth();
    const assistanceService = new AssistanceService();
    const [selectedAssistance, setSelectedAssistance] = useState<SelectItemsProps | null>(null);
    const [inputAssistance, setInputAssistance] = useState<number | null>(null);
    const { id } = useParams<{ id: string; }>();
    const navigate = useNavigate();
    const intl = useIntl()
    const service = new ClientQuotationService()
    const [clientQuotation, setClientQuotation] = useState<ClientQuotationDTO>({} as ClientQuotationDTO);
    const [loading, setLoading] = useState<boolean>(true);
    // Guarda síncrona contra duplo clique no envio de peças para a assistência (evita linhas duplicadas no PHC).
    // O disabled={loading} é baseado em estado e não bloqueia dois cliques rápidos no mesmo render.
    const isSendingPartsRef = useRef<boolean>(false);
    const openDate = clientQuotation.openDate ? new Date(clientQuotation.openDate) : null;
    const formattedOpenDate = openDate ? `${openDate.getDate()}-${openDate.getMonth() + 1}-${openDate.getFullYear()}` : '';
    const closeDate = clientQuotation.closeDate ? new Date(clientQuotation.closeDate) : null;
    const formattedCloseDate = closeDate ? `${closeDate.getDate()}-${closeDate.getMonth() + 1}-${closeDate.getFullYear()}` : '';
    const [parts, setParts] = useState<PartsAndServicesQuotationDTO[]>([]);
    const [totalValue, setTotalValue] = useState<number>(0);
    const [costPrice, setCostPrice] = useState<number>(0);
    const [selectedStatus, setSelectedStatus] = useState<SelectItemsProps | null>(null);
    const [inputDescription, setInputDescription] = useState<string>("");
    const [isEditable, setIsEditable] = useState<boolean>(false);
    const [isPendingApproval, setIsPendingApproval] = useState<boolean>(false);
    const clientQuotationService = new ClientQuotationService();
    const [modalOpen, setModalOpen] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [isRejection, setIsRejection] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState("");
    const [confirmText, setConfirmText] = useState("");
    const [confirmButtonLeft, setConfirmButtonLeft] = useState("");
    const [confirmButtonRight, setConfirmButtonRight] = useState("");
    const [assistModalOpen, setAssistModalOpen] = useState(false);
    const [onConfirmAction, setOnConfirmAction] = useState<() => Promise<void> | void>(() => { });
    const [onCancelAction, setOnCancelAction] = useState<() => void>(() => { });
    const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
    const [newQuotationDuplicatedId, setNewQuotationDuplicatedId] = useState<number | null>(null);
    const { availableModules } = useAvailableModulesContext();


    const [isActiveSupplierQuotation, setIsActiveSupplierQuotation] = useState<boolean>(false);
    useEffect(() => {
        if (availableModules.includes("IsActiveSupplierQuotation")) {
            setIsActiveSupplierQuotation(true);
        }
    }, [availableModules]);

    function openConfirm(options: {
        title: string;
        text: string;
        buttonLeft?: string;
        buttonRight?: string;
        onConfirm: () => Promise<void> | void;
        onCancel?: () => void;
    }) {
        setConfirmTitle(options.title);
        setConfirmText(options.text);
        setConfirmButtonLeft(options.buttonLeft ?? "Sim");
        setConfirmButtonRight(options.buttonRight ?? "Não");
        setOnConfirmAction(() => options.onConfirm);
        setOnCancelAction(() => options.onCancel ?? (() => setConfirmOpen(false)));
        setConfirmOpen(true);
    }

    const canViewIndex = () => {
        if (!userRoles) return false;
        return userRoles.includes("Admin") || userRoles.includes("Técnico Escritório");
    };

    const calculateTotalValue = (parts?: PartsAndServicesQuotationDTO[] | null) => {
        const safeParts = parts ?? [];
        setParts(safeParts);

        let sum = 0;
        safeParts.forEach(part => {
            sum += Utilities.calculateTotalPrice(part.quantity, part.sellingPrice);
        });
        return sum;
    };

    const calculateCostValue = (parts?: PartsAndServicesQuotationDTO[] | null) => {
        const safeParts = parts ?? [];

        let sum = 0;
        safeParts.forEach(part => {
            sum += Utilities.calculateTotalPrice(part.quantity, part.costPrice);
        });
        return sum;
    };

    const handleTotalPartsChange = (parts: PartsAndServicesQuotationDTO[]) => {
        setTotalValue(calculateTotalValue(parts));
        setCostPrice(calculateCostValue(parts));
    }

    const getById = async () => {
        setLoading(true);
        let response;
        if (availableModules.includes("IsActiveErpClientQuotation")) {
            const { docType, serie, number } = location.state || {};
            if (docType && serie && typeof number !== "undefined") {
                const getAssistanceDTO = {
                    docType,
                    serie,
                    number: Number(number)
                };
                response = await clientQuotationService.CreateDbFromErp(getAssistanceDTO);
            } else {
                Toast.Show("error", "Parâmetros ERP em falta para consulta de proposta.");
                setLoading(false);
                return;
            }
        } else {
            response = await service.GetById(Number(id));
        }
        if (response.success === false || !response.obj || typeof response.obj.id === "undefined") {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
        }
        setClientQuotation(response.obj);
        setIsEditable(response.obj.status?.statusEnumValue === "EM_PREPARACAO" || response.obj.status?.statusEnumValue === "RE_ANALISE");
        setIsPendingApproval(response.obj.status?.statusEnumValue === "ESPERA_APROVACAO");
        setIsFinished(response.obj.status?.statusEnumValue === "REJEITADO" || response.obj.status?.statusEnumValue === "APROVADO" || response.obj.status?.statusEnumValue === "CANCELADA");
        setIsRejection(response.obj.status?.statusEnumValue === "REJEITADO");
        setParts(response.obj.partsAndServicesQuotations);
        setTotalValue(response.obj.sellingPrice);
        if (response.obj.assistance) {
            setSelectedAssistance({
                value: response.obj.assistance.id.toString(),
                label: `${response.obj.assistance.erpDocType} ${response.obj.assistance.erpSerie} ${response.obj.assistance.erpNumDoc}`
            });
            setInputAssistance(response.obj.assistance.id);
        }
        setInputDescription(response.obj.description);
        setLoading(false);
    }

    useEffect(() => {
        getById();
    }, [id])

    const openDecisionModal = (reject: boolean) => {
        setIsRejection(reject);
        setModalOpen(true);
    };
    const handleSubmit = async (data: {
        acceptanceMode: string;
        observations: string;
        rejectionMotive?: string;
    }) => {
        const status = isRejection ? "Rejeitado" : "Aprovado";
        if (!id) {
            console.error('ID ou Status não definidos');
            return;
        }
        const approveClientQuotationDTO: ApproveClientQuotationDTO = {
            status,
            acceptanceMode: data.acceptanceMode,
            observations: data.observations,
            rejectionMotive: data.rejectionMotive, // Este campo é opcional
        };



        setLoading(true);
        try {
            const numericId = Number(id);
            const result = await service.TecnicianUpdateStatus(numericId, approveClientQuotationDTO);

            if (result.success) {
                Toast.Show("success", `Status atualizado com sucesso`);
                await getById();
            } else {
                Toast.Show("error", result.message);
            }

        } catch (error) {
            console.error("Erro ao chamar o servidor:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = async (quotationId: number) => {
        openConfirm({
            title: intl.formatMessage({ id: "Screens.ClientQuotation.Cancel.Confirm.Title" }),
            text: intl.formatMessage({ id: "Screens.ClientQuotation.Cancel.Confirm" }),
            onConfirm: async () => {
                setLoading(true);

                try {
                    const response = await service.Cancel(quotationId);

                    if (response.success) {
                        Toast.Show("success", intl.formatMessage({ id: "Screens.ClientQuotation.Cancel.Success" }));
                        await getById(); // atualiza o estado
                    } else {
                        Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.ClientQuotation.Cancel.Error" }));
                    }
                } catch (error) {
                    console.error("Erro ao cancelar a proposta:", error);
                    Toast.Show("error", intl.formatMessage({ id: "Screens.ClientQuotation.Cancel.Error" }));
                } finally {
                    setLoading(false);
                }
            }
        });
    };
    const searchAssistance = async (
        docNumber: string
    ): Promise<SelectItemsProps[]> => {
        if (!clientQuotation.client?.erpId) {
            Toast.Show("error", intl.formatMessage({ id: "Screens.ClientQuotation.ChooseAssistance.WithoutClientErpId" }));
            return [];
        }
        const parameters: Parameter[] = [
            new Parameter('numDoc', docNumber),
            new Parameter('clientErpId', clientQuotation.client.erpId.toString())
        ];
        const response = await assistanceService.GetAll(parameters, [], 1, 10);

        if (response.success === false || !response.items) {
            Toast.Show("error", response.message);
        }

        const list: SelectItemsProps[] = [];
        response.items?.forEach((element) => {
            const item: SelectItemsProps = {
                value: element.assistanceId?.toString() ?? "",
                label: element.docType + " " + element.serie.toString() + " " + element.number.toString(),
            };
            console.log(element)
            //condição para verificar o status da assientencia usando o statusEnumValue
            if (element.statusEnumValue !== "FECHADA_TECNICAMENTE" && element.statusEnumValue !== "VALIDADA" && element.statusEnumValue !== "FECHADA_FINANCEIRAMENTE") {
                list.push(item);
            }
        });
        return list;
    };

    const handleSubmitBoton = async () => {
        setLoading(true);

        calculateTotalValue(parts ?? []);

        const partsAndServicesQuotationDTO: PartsAndServicesQuotationDTO[] = [];
        parts.forEach(part => {
            const partAndServices: PartsAndServicesQuotationDTO = {
                partName: part.partName,
                partId: part.partId,
                quotationId: clientQuotation.id,
                quantity: part.quantity,
                sellingPrice: part.sellingPrice,
                costPrice: part.costPrice,
                totalSellingPrice: Utilities.calculateTotalPrice(part.quantity, part.sellingPrice),
            };
            partsAndServicesQuotationDTO.push(partAndServices);
        });

        const clientQuotationDTO: UpdateClientQuotationDTO = {
            quotationId: clientQuotation.id,
            assistanceId: inputAssistance || clientQuotation.assistanceId,
            description: inputDescription || clientQuotation.description,
            clientId: clientQuotation.clientId,
            partsAndServicesQuotationDTO: partsAndServicesQuotationDTO,
            sellingPrice: totalValue,
            costPrice: costPrice,
        };
        const response = await clientQuotationService.Update(clientQuotationDTO, clientQuotation.id)

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
        }
        Toast.Show("success", intl.formatMessage({ id: "Screens.ClientQuotation.Parts.Edit.Success", }));

        setLoading(false);
        if (canViewIndex()) {
            navigate(`${Routes.clientQuotations.list}`);
        }
        else {
            navigate(`${Routes.oficina.details}/${clientQuotation.assistanceId}`);
        }
    };
    const handleChangeAssistance = async (assistanceID: number) => {
        setLoading(true);



        const clientQuotationDTO: UpdateClientQuotationAssistanceDTO = {
            quotationId: clientQuotation.id,
            assistanceId: assistanceID || clientQuotation.assistanceId,
        };
        const response = await clientQuotationService.UpdateAssistance(clientQuotationDTO, clientQuotation.id)

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
        }
        Toast.Show("success", intl.formatMessage({ id: "Screens.ClientQuotation.Parts.Edit.Success", }));

        setLoading(false);
    };
    const handleSendEmail = async (id: number) => {

        openConfirm({
            title: intl.formatMessage({ id: "Screens.ClientQuotation.Email.Confirm.Title" }),
            text: intl.formatMessage({ id: "Screens.ClientQuotation.Email.Confirm" }) + ` ${clientQuotation.client.email}`,
            onConfirm: async () => {
                try {
                    setLoading(true);
                    const response = await clientQuotationService.SendEmail(id); // Chamar o serviço para enviar o email
                    if (response.success) {
                        Toast.Show("success", intl.formatMessage({ id: "Screens.Quotation.SendEmail.Success" }));
                    } else {
                        Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.Quotation.SendEmail.Error" }));
                    }
                    setLoading(false);
                    getById();
                } catch (error) {
                    console.error("Erro ao enviar o email:", error);
                    Toast.Show("error", "Screens.Quotation.SendEmail.Error");
                }
            }
        });
    };
    const handleDuplicate = async (original: ClientQuotationDTO) => {

        setLoading(true);
        const detailResp = await clientQuotationService.GetById(original.id);
        if (!detailResp.success || !detailResp.obj) {
            Toast.Show("error", detailResp.message || intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Error" }));
            setLoading(false);
            return;
        }
        const full = detailResp.obj;

        const partsAndServicesQuotationDTO: PartsAndServicesQuotationDTO[] =
            full.partsAndServicesQuotations.map((p) => ({
                partId: p.partId,
                partName: p.partName,
                quantity: p.quantity,
                sellingPrice: p.sellingPrice,
                costPrice: p.costPrice,
                totalSellingPrice: p.totalSellingPrice,
            }));
        const dto: CreateClientQuotationDTO = {
            clientErpId: full.client.erpId,
            clientId: full.client.id,
            description: full.description,
            notes: "",
            partsAndServicesQuotationDTO,
            sellingPrice: full.sellingPrice,
            costPrice: full.costPrice,
        };

        const response = await clientQuotationService.Create(dto);
        setLoading(false);
        if (response.success) {
            setNewQuotationDuplicatedId(response.obj);
            setDuplicateModalOpen(true);
        } else {
            Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Error" }));
        }
    };

    const handleDelete = async (id: number) => {
        openConfirm({
            title: intl.formatMessage({ id: "Screens.ClientQuotation.Delete.Confirm.Title" }),
            text: intl.formatMessage({ id: "Screens.ClientQuotation.Delete.Confirm" }),
            onConfirm: async () => {
                setLoading(true);
                const response = await clientQuotationService.softDeleteClientQuotation(id);
                if (!response.success) {
                    Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.ClientQuotation.Delete.Error" }));
                    setLoading(false);
                    return;
                }

                setLoading(false);
                if (response.success) {
                    Toast.Show("success", intl.formatMessage({ id: "Screens.ClientQuotation.Delete.Success" }));
                    navigate(`${Routes.clientQuotations.list}`);
                } else {
                    Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.ClientQuotation.Delete.Error" }));
                }
            }
        });
    };
    const handleSendPartsToAssistance = async (id: number) => {
        // Impede um segundo envio enquanto o primeiro ainda está em curso.
        if (isSendingPartsRef.current) {
            return;
        }
        isSendingPartsRef.current = true;

        try {
            setLoading(true);
            const response = await clientQuotationService.SendPartsToAssistance(id);
            if (response.success) {
                Toast.Show("success", intl.formatMessage({ id: "Screens.Quotation.SendParts.Success" }));
            } else {
                Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.Quotation.SendParts.Error" }));
            }
            getById();
        } catch (error) {
            console.error("Erro ao enviar o email:", error);
            Toast.Show("error", "Screens.Quotation.SendParts.Error");
        } finally {
            setLoading(false);
            isSendingPartsRef.current = false;
        }
    };


    return (
        <Layout>
            <ModalComponent
                IsOpen={confirmOpen}
                title={confirmTitle}
                text={confirmText}
                buttonLeft={confirmButtonLeft}
                buttonRight={confirmButtonRight}
                OnClickLeft={async () => {
                    setConfirmOpen(false);
                    await onConfirmAction();
                }}
                OnClickRight={() => {
                    setConfirmOpen(false);
                    onCancelAction();
                }}
            />
            <ModalComponent
                IsOpen={duplicateModalOpen}
                title={intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Success.Title" })}
                text={intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Success.Text" })}
                buttonLeft={intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Button.ViewNew" })}
                buttonRight={intl.formatMessage({ id: "Screens.ClientQuotation.Duplicate.Button.Cancel" })}
                OnClickLeft={() => {
                    if (newQuotationDuplicatedId) {
                        navigate(Routes.clientQuotations.details.replace(':id', newQuotationDuplicatedId!.toString()));
                    }
                    setDuplicateModalOpen(false);
                }}
                OnClickRight={() => {
                    setDuplicateModalOpen(false);
                }}
            />
            <div className="pageContainer">
                <div className="pageHeader">
                    <span className="pageTitle">
                        <Row className="pageHeader" style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <Col xl={4} lg={4} md={12} sm={12} xs={12} style={{ display: "flex", margin: "0px" }}>
                                <PageTitle
                                    title={`${intl.formatMessage({ id: "Screens.ClientQuotation" })} ${clientQuotation.id}`}
                                    allowGoBack={true}
                                />
                            </Col>
                            <Col
                                xl={8}
                                lg={8}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    flexWrap: "wrap",
                                    gap: "0.5rem",
                                }}
                            //aqui abiaxo está o que queremos
                            >
                                {clientQuotation?.status?.frontendName ? (
                                    <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                        {intl.formatMessage({ id: "Screens.ClientQuotation.Header.Status" })}
                                        <span style={{ textTransform: "uppercase" }}>{clientQuotation.status.frontendName}</span>
                                    </span>
                                ) : (
                                    <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                        {intl.formatMessage({ id: "Screens.ClientQuotation.Header.Status" })}
                                        <span style={{ textTransform: "uppercase" }}></span>
                                    </span>
                                )}
                                {canViewIndex() && (
                                    <>
                                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                            {
                                                clientQuotation.status?.statusEnumValue === "APROVADO" /* Aprovado */
                                                && (
                                                    <>
                                                        <ButtonComponent
                                                            disabled={loading}
                                                            loading={loading}
                                                            text={intl.formatMessage({ id: "Screens.ClientQuotation.Button.SendParts" })}
                                                            onClick={() => {
                                                                if (clientQuotation.assistanceId) {
                                                                    handleSendPartsToAssistance(clientQuotation.id);
                                                                } else {
                                                                    setAssistModalOpen(true);
                                                                }
                                                            }}
                                                        />

                                                        <SelectAssistanceModal
                                                            isOpen={assistModalOpen}
                                                            toggle={() => setAssistModalOpen(false)}
                                                            clientErpId={clientQuotation.client.erpId}
                                                            onSelect={async (ass) => {


                                                                await handleChangeAssistance(Number(ass.value));
                                                                await getById();
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            <ButtonComponent
                                                disabled={loading}
                                                loading={loading}
                                                text={intl.formatMessage({ id: "Screens.ClientQuotation.Button.Duplicate" })}
                                                onClick={() => handleDuplicate(clientQuotation)}
                                            />

                                            {clientQuotation.status?.statusEnumValue === "EM_PREPARACAO" /*Em Preparacao*/ && (
                                                <ButtonComponent
                                                    disabled={loading}
                                                    loading={loading}
                                                    text={intl.formatMessage({ id: "Screens.ClientQuotation.Button.Delete" })}
                                                    onClick={() => handleDelete(clientQuotation.id)}
                                                />
                                            )}

                                            {isEditable && (
                                                <ButtonComponent
                                                    disabled={loading}
                                                    loading={loading}
                                                    text={intl.formatMessage({ id: "Screens.ClientQuotation.Button.SendEmail" })}
                                                    onClick={() => handleSendEmail(Number(id))}
                                                />
                                            )}
                                        </div>
                                        {isPendingApproval && (
                                            <>


                                                <ButtonComponent
                                                    disabled={loading} // Desabilita o botão enquanto estiver carregando
                                                    loading={loading} // Exibe o loading spinner
                                                    text="Aceitar"
                                                    onClick={() => openDecisionModal(false)} // Abre o decision modal com reject a façse
                                                />


                                                <ButtonComponent
                                                    disabled={loading} // Desabilita o botão enquanto estiver carregando
                                                    loading={loading} // Exibe o loading spinner
                                                    text="Recusar"
                                                    onClick={() => openDecisionModal(true)} // Abre o decision modal com reject a true
                                                />


                                                <DecisionModal
                                                    isOpen={modalOpen}
                                                    toggle={() => setModalOpen(false)}
                                                    isRejection={isRejection}
                                                    onSubmit={handleSubmit}
                                                />
                                            </>
                                        )}
                                        {!isFinished && (
                                            <ButtonComponent
                                                disabled={loading} // Desabilita o botão enquanto estiver carregando
                                                loading={loading} // Exibe o loading spinner
                                                text="Cancelar"
                                                onClick={() => handleCancel(clientQuotation.id)} // Abre o decision modal com reject a true
                                            />
                                        )}
                                    </>
                                )}
                            </Col>
                        </Row>
                    </span>
                </div>
                <div className="pageBody">
                    {loading ? (
                        <div>Loading...</div>
                    ) : (
                        <>
                            <Row style={{ margin: "0px", padding: "0px" }}>
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={5}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "75%" }}
                                    type={"text"}
                                    value={clientQuotation.client ? clientQuotation.client.name : ''}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Client",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={3}
                                    lg={3}
                                    md={4}
                                    style={{ width: "50" }}
                                    type={"text"}
                                    value={clientQuotation.client ? clientQuotation.client.email : ''}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Client.Email",
                                    })}
                                    readOnly={true}
                                />
                                {isActiveSupplierQuotation && (
                                    <InputComponent
                                        xl={2}
                                        lg={2}
                                        md={2}
                                        sm={5}
                                        xs={5}
                                        style={{ width: "30%" }}
                                        type={"text"}
                                        value={clientQuotation.supplierQuotationId ? clientQuotation.supplierQuotationId.toString() : ''}
                                        label={intl.formatMessage({
                                            id: "Screens.Quotation.Info.SupplierQuotation",
                                        })}
                                        readOnly={true}
                                    />
                                )}
                                <InputComponent
                                    xl={2}
                                    lg={2}
                                    md={3}
                                    sm={9}
                                    xs={9}
                                    style={{ width: "40%" }}
                                    type={"text"}
                                    value={formattedOpenDate}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.OpenDate",
                                    })}
                                    readOnly={true}
                                />
                                <Row style={{ margin: "0px", padding: "0px" }}>
                                    <InputComponent
                                        xl={2}
                                        lg={2}
                                        md={3}
                                        sm={9}
                                        xs={9}
                                        style={{ width: "40%" }}
                                        type={"text"}
                                        value={formattedCloseDate !== '1-1-1' ? formattedCloseDate : null}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.CloseDate",
                                        })}
                                        readOnly={true}
                                    />
                                    {isEditable ? (
                                        <SearchSelectComponent
                                            xl={2} lg={2} md={3} sm={6}
                                            xs={6}
                                            label={intl.formatMessage({ id: "Screens.Quotation.Info.Assistance" })}
                                            loadOptions={searchAssistance}
                                            onChange={e => {
                                                setSelectedAssistance(e);
                                                setInputAssistance(Number(e.value));
                                            }}
                                            value={selectedAssistance}
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <InputComponent
                                            xl={2} lg={2} md={3} sm={6}
                                            xs={6}
                                            type="text"
                                            value={selectedAssistance?.label || ''}
                                            label={intl.formatMessage({ id: "Screens.Quotation.Info.Assistance" })}
                                            readOnly={true}
                                        />
                                    )}
                                </Row>
                            </Row>
                            <Row style={{ margin: "0px", padding: "0px" }}>
                                <InputComponent
                                    xl={8}
                                    lg={8}
                                    md={10}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={inputDescription}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Description",
                                    })}
                                    required={true}
                                    readOnly={!isEditable}
                                    onChange={(t: string) => setInputDescription(t)}
                                />
                            </Row>
                            {clientQuotation.magicLinkToken != null && (
                                <Row style={{ margin: "0px", padding: "0px" }}>
                                    <InputComponent
                                        xl={8}
                                        lg={8}
                                        md={10}
                                        sm={12}
                                        xs={12}
                                        style={{ width: "100%" }}
                                        type={"text"}
                                        value={clientQuotation.magicLinkToken ?? ''}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.MagicLink",
                                        })}
                                        readOnly={true}
                                    />
                                </Row>)}
                            <DetailsQuotationPartsTable
                                isEditable={isEditable}
                                reloadParts={true}
                                goToPage={0}
                                currentPage={0}
                                isComplete={false}
                                onPartsChange={handleTotalPartsChange}
                                initialParts={parts}
                                quotationType={clientQuotation?.quotationType}
                                id={Number(id)}
                                clientId={clientQuotation?.client?.id ?? 0}
                                description={clientQuotation?.description ?? ""} />

                            <Row style={{ margin: "0px", padding: "0px" }}>
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={5}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={clientQuotation.notes}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Notes",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={5}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "20%" }}
                                    type={"text"}
                                    value={totalValue.toString()}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.TotalValue",
                                    })}
                                    readOnly={true}
                                />
                            </Row>
                            {isFinished && (
                                <Row style={{ margin: "0px", padding: "0px" }}>
                                    <InputComponent
                                        xl={2}
                                        lg={2}
                                        md={3}
                                        sm={8}
                                        xs={8}
                                        style={{ width: "100%" }}
                                        type={"text"}
                                        value={clientQuotation.acceptanceMode}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.AcceptanceMode",
                                        })}
                                        readOnly={true}
                                    />
                                    <InputComponent
                                        xl={4}
                                        lg={4}
                                        md={5}
                                        sm={12}
                                        xs={12}
                                        style={{ width: "100%" }}
                                        type={"text"}
                                        value={clientQuotation.observations}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.Observations",
                                        })}
                                        readOnly={true}
                                    />
                                    {isRejection && (
                                        <InputComponent
                                            xl={4}
                                            lg={4}
                                            md={5}
                                            sm={12}
                                            xs={12}
                                            style={{ width: "100%" }}
                                            type={"text"}
                                            value={clientQuotation.rejectionMotive}
                                            label={intl.formatMessage({
                                                id: "Screens.ClientQuotation.Info.RejectionMotive",
                                            })}
                                            readOnly={true}
                                        />
                                    )}
                                </Row>
                            )}
                            {isEditable && (
                                <Row style={{ margin: "0px", padding: "8px" }}>
                                    <Col>
                                        <ButtonComponent
                                            disabled={loading}
                                            loading={loading}
                                            text={intl.formatMessage({
                                                id: "Screens.ClientQuotation.Button.Create",
                                            })}
                                            onClick={handleSubmitBoton}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}